import {
  Button,
  Card,
  CircularProgress,
  Collapse,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Fade,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Snackbar,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { withAuthorization } from "../Session";
import * as FORM_TYPES from "../../constants/registerFormTypes";
import { useTranslation } from "react-i18next";
import { DatePicker, DateTimePicker, KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import * as ROUTES from "../../constants/routes";
import Lottie from "lottie-react";
import RequiredFieldsCard from "./RequiredFieldsCard";
import { grey, red } from "@material-ui/core/colors";
import { Check, Delete, FilterNone } from "@material-ui/icons";
import CustomFields from "./CustomFields";
import SignUpForm from "../RescuerSignUp/SignUpForm";
import moment from "moment";
import FormConfigCard from "./FormConfigCard";
import { useHistory, useLocation } from "react-router-dom";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import NameTranslate from "./NameTranslate";

const initialState = {
  titles: { es: "", en: "", eu: "" },
};

const MetaForms = (props) => {
  console.log(props, "---------------");
  const { firebase } = props;
  const { t } = useTranslation();
  const { formId } = useParams();
  const history = useHistory();
  const location = useLocation();

  const QRCode = require("qrcode.react");

  const [preview, setpreview] = useState(false);
  const [availableGroups, setAvailableGroups] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [name, setName] = useState({});
  const [formName, setFormName] = useState("");
  const [program, setProgram] = useState("");
  const [group, setGroup] = useState("");
  const [formType, setFormType] = useState(FORM_TYPES.FREE);
  const [startDay, setStartDay] = useState(new Date());
  const [endDay, setEndDay] = useState(new Date());
  const [alertEnabled, setAlertEnabled] = useState(false);
  const [workshops, setWorkshops] = useState([]);
  const [workshopsMainLocation, setWorkshopsMainLocation] = useState("");
  const [customFieldsList, setCustomFieldsList] = useState([]);
  const [isFormCreated, setIsFormCreated] = useState(false);
  const [formUrl, setFormUrl] = useState("");
  const [snackOpen, setSnackOpen] = useState(false);
  const [formExist, setFormExist] = useState(false);
  const [isEdditing, setIsEdditing] = useState(false);
  const [isRefreshmentGroups, setisRefreshmentGroups] = useState(true);
  const [refreshmentGroups, setRefreshmentGroups] = useState([]);
  const [refreshmentGroupsData, setRefreshmentGroupsData] = useState({ duration: 0, startDay: null, endDay: null, place: "" });
  const [othersForms, setOthersForms] = useState([]);
  const [excludedFormsList, setExcludedFormsList] = useState([]);
  const [refreshmentHastUSers, setRefreshmentHastUSers] = useState(false);
  const [isWorking, setIsWorking] = useState(false);

  useEffect(() => {
    firebase
      .managerData(firebase.currentUser().uid)
      .child("forms/available")
      .once("value")
      .then((snap) => {
        setAvailableGroups(snap.val());
        !location.pathname.split("/").includes(ROUTES.METAFORMS) && checkIseditForm();
        setFormExist(true);
      });
  }, []);

  const checkIseditForm = () => {
    if (location.pathname.split("/").includes(ROUTES.EDIT_METAFORM_EXACT)) {
      firebase
        .rescuersFormsRef(formId)
        .once("value")
        .then((snap) => {
          const f = snap.val();
          setIsEdditing(true);
          if (!!f) {
            let titles = f.titles === undefined ? initialState.titles : f.titles; // para ser compatibles con las primeras versiones del formulario
            setName(titles);
            setProgram(f.programId);
            setGroup(f.groupId);
            setAlertEnabled(f.alertEnabled);
            setFormType(f.type);
            setStartDay(moment(f.startDay, "DD/MM/YYYY"));
            setEndDay(moment(f.endDay, "DD/MM/YYYY"));
            setWorkshopsMainLocation(f?.formationGroups[0]?.mainPlace);
            setFormName(f.name);
            setFormExist(true);
            setisRefreshmentGroups(f.isRefreshmentGroups);
            firebase
              .managerData(firebase.currentUser().uid)
              .child(`forms/created/${formId}`)
              .once("value")
              .then((snap) => {
                const newGroups = snap.val()?.formConfig?.formationGroups;
                const refreshGroup = snap.val()?.formConfig?.refreshmentGroups;
                setWorkshops(f.formationGroups.map((fg, i) => ({ ...fg, /* time: fg.time "dddd DD MMM HH:mm"*/ hasRescuers: Array.isArray(newGroups[i]?.rescuers) })));
                if (f.isRefreshmentGroups) {
                  setRefreshmentGroupsData({
                    duration: f.refreshmentGroups.duration,
                    startDay: moment(f.refreshmentGroups.startDay, "DD/MM/YYYY"),
                    endDay: moment(f.refreshmentGroups.endDay, "DD/MM/YYYY"),
                    place: f.refreshmentGroups.place,
                  });
                  setRefreshmentGroups(f.refreshmentGroups.groups.map((k, i) => ({ ...k, hasRescuers: Array.isArray(refreshGroup[i].rescuers) })));
                  // se revisa si hay algún voluntario en alguno de los grupos, en caso de haber, no se podra poner "cursos de refresco" a no
                  setRefreshmentHastUSers(f?.refreshmentGroups?.groups?.map((k, i) => Array.isArray(refreshGroup[i].rescuers)).reduce((a, b) => a || b, false));
                }
              });

            getOtherGroupsWithSameId(f.programId, f.groupId);
          } else {
            setFormExist(false);
          }
          setTimeout(() => {
            setIsLoading(false);
          }, 750);
        });
    } else {
      setTimeout(() => {
        setIsLoading(false);
      }, 750);
    }
  };

  const getOtherGroupsWithSameId = (programId, groupId) => {
    //se descargan los datos de los demás cursos por si se quieren descartar los datos
    firebase
      .managerData(firebase.currentUser().uid)
      .child("forms/created")
      .once("value")
      .then((snap) => {
        const othersForms = snap.val();

        let sameGourpForms = [];
        let currentVolunteers = 0;
        Object.keys(othersForms).forEach((k) => {
          /** TODO: mejorar el conteo de los usuarios */
          if (othersForms[k].formConfig.groupId === groupId && othersForms[k].formConfig.programId === programId) {
            othersForms[k]?.formConfig?.formationGroups?.forEach((e) => {
              currentVolunteers += e?.rescuers?.length;
            });
            othersForms[k]?.formConfig?.refreshmentGroups?.forEach((e) => {
              currentVolunteers += e?.rescuers?.length;
            });
            sameGourpForms.push({ key: k, ...othersForms[k], rescuers: currentVolunteers });
            currentVolunteers = 0;
          }
        });
        setOthersForms(sameGourpForms);
      });
  };

  useEffect(() => {
    if (program !== "" && group !== "") {
      getOtherGroupsWithSameId(program, group);
    }
  }, [program, group]);

  useEffect(() => !isEdditing && setGroup(""), [program]);

  let isValid =
    program !== "" &&
    group !== "" &&
    formName !== "" &&
    name?.es !== undefined &&
    name?.es !== "" &&
    workshops.length > 0 &&
    workshops.every((r) => !!r.time && Number.isFinite(Number(r.capacity)) && Number(r.capacity) >= 0) &&
    (!isRefreshmentGroups ||
      (refreshmentGroups.length > 0 &&
        Object.keys(refreshmentGroupsData)
          .map((k) => !!refreshmentGroupsData[k])
          .every(Boolean) &&
        refreshmentGroups.every((r) => !!r.time && Number.isFinite(Number(r.capacity)) && Number(r.capacity) >= 0)));

  const uploadFormData = () => {
    setIsWorking(true);

    /* Se comprueban los títulos en los diferenes idiomas para, si no están completos, completarlos con el castellano por defecto */
    ["eu", "en"].forEach((l) => {
      if (name[l] == undefined || name[l] == "") {
        name[l] = name["es"];
      }
    });
    /*----------------------------------------------------------------------*/

    const formData = {
      name: formName, // se cambia name por formName para que solo exista un nombre que mostrar
      titles: name,
      programId: program,
      groupId: group,
      alertEnabled: alertEnabled,
      type: formType,
      managerUid: firebase.currentUser().uid,
      startDay: moment(startDay).format("DD/MM/YYYY"),
      endDay: moment(endDay).format("DD/MM/YYYY"),
      customFields: {}, //añadir cuando sea necesario gestionar los campos personalizables
      formationGroups: workshops.map((w) => {
        const cap = Number(w.capacity) || 0;
        return {
          text: `${workshopsMainLocation} ${w.locationDetail} · ${moment(w.time).format("dddd DD MMM HH:mm")}`,
          place: `${workshopsMainLocation} ${w.locationDetail}`,
          mainPlace: workshopsMainLocation,
          locationDetail: w.locationDetail,
          time: moment(w.time).valueOf(),
          capacity: cap,
          remaining: cap,
        };
      }),
      isRefreshmentGroups: isRefreshmentGroups,
    };

    if (isRefreshmentGroups) {
      /* en caso de haber refresco se añade la información de los refrescos */
      formData.refreshmentGroups = refreshmentGroups.map((r) => {
        const cap = Number(r.capacity) || 0;
        return {
          time: moment(r.time).valueOf(),
          capacity: cap,
          remaining: cap,
        };
      });
    }

    const formMetada = { created: new Date().getTime(), isEdited: false };
    const managerRef = firebase.managerData(firebase.currentUser().uid);

    if (!isEdditing) {
      /* si es un nuevo formulario se registra */

      managerRef
        .child("forms/created")
        .push({ formConfig: formData, meta: formMetada })
        .then((e) => {
          const UsersUpdateListenerRef = managerRef.child(`forms/created/${e.key}/formConfig/allUsersUpdated`);
          const refreshGroupUserData = {
            [e.key]: {
              startDay: moment(refreshmentGroupsData.startDay).format("DD/MM/YYYY"),
              endDay: moment(refreshmentGroupsData.endDay).format("DD/MM/YYYY"),
              isReviewed: false,
            },
          };
          formData.refreshmentGroups = {
            ...refreshmentGroupsData,
            startDay: moment(refreshmentGroupsData.startDay).format("DD/MM/YYYY"),
            endDay: moment(refreshmentGroupsData.endDay).format("DD/MM/YYYY"),
            groups: refreshmentGroups.map((r) => {
              const cap = Number(r.capacity) || 0;
              return {
                time: moment(r.time).valueOf(),
                locationDetail: r.locationDetail != undefined ? r.locationDetail : null,
                capacity: cap,
                remaining: cap,
              };
            }),
          };
          /** se crea un listener en el nodo de la base de datos que
           *  indica que se han actualizado todos los usuarios, en caso de ser
           *  un grupo no creado, se crea y se actualiza el
           *  nodo para que temine el proceso de creación */
          const listener = UsersUpdateListenerRef.on("value", (snap) => {
            if (snap.val()) {
              /* Se genera la RUL y el QR para mostrar al usuario */
              const generatedUrl = `${window.location.href.split("/createSingUpForm")[0]}/courseRegistration/${e.key}`;
              e.child("formConfig").update({ url: generatedUrl });
              setFormUrl(generatedUrl);
              firebase
                .rescuersFormsRef(e.key)
                .update({ ...formData })
                .then(() => {
                  setIsFormCreated(true);
                  setIsWorking(false);
                });
              console.log("se han actualizado todos los datos");
              UsersUpdateListenerRef.off("value", listener);
            }
          });

          managerRef
            .child(`programs/${program}/groups/${group}`)
            .once("value")
            .then((snap) => {
              const mg = snap.val();
              /**  Si tiene datos, significa que el grupo ya habia sido creado,
               *   por tanto se revisa la lsita de usuarios que hay en el programa
               *   para añadirles la información del curso de refreso  */
              if (snap.exists()) {
                if (isRefreshmentGroups) {
                  //si tiene cursos de fregresco, añade los usuarios para que sean notificados
                  /* añade de forma asincrona a los usuarios la información del curso de refresco */
                  let excludedUsers = [];
                  /* Se crea la lista de los usuarios a los 
                   que hay que añadir el nuevo formulario, 
                   se tiene en cuenta la lista de formularios excluidos */
                  console.table(mg);
                  console.table(othersForms);
                  Object.keys(othersForms).forEach((k) => {
                    if (excludedFormsList.includes(othersForms[k].key)) {
                      othersForms[k]?.formConfig?.formationGroups?.forEach((e) => {
                        excludedUsers = excludedUsers.concat(e?.rescuers?.map((r) => r.uid));
                      });
                      othersForms[k]?.formConfig?.refreshmentGroups?.forEach((e) => {
                        excludedUsers = excludedUsers.concat(e?.rescuers?.map((r) => r.uid));
                      });
                    }
                  });
                  excludedUsers = excludedUsers.filter((k) => k !== undefined);
                  mg.rescuers = mg?.rescuers?.filter((k) => !excludedUsers.includes(k));
                  console.log("Se genera la información a los usuarios: ", mg.rescuers);
                  addNewCourseToUsers(UsersUpdateListenerRef, mg.rescuers, refreshGroupUserData);
                } else {
                  UsersUpdateListenerRef.parent.update({ allUsersUpdated: true });
                }
              } else {
                /* Si no hay información del grupo, no puede haber usuarios registrados para ese grupo,
                 por tanto, se genera la estructura de datos del grupo y se le añade al manager */
                managerRef
                  .child(`programs/${program}`)
                  .update({
                    name: availableGroups[program].name,
                    groups: {
                      [group]: {
                        name: availableGroups[program].groups[group].name,
                        rescuers: [],
                        currentPeriod: {
                          lastFormationDate: new Date().getTime(),
                          reminderDate: moment().add(6, "months").valueOf(),
                          transitionEnds: moment().add(3, "months").valueOf(),
                        },
                      },
                    },
                  })
                  .then(() => {
                    UsersUpdateListenerRef.parent.update({ allUsersUpdated: true });
                  });
              }
            });
        });
    } else {
      /* Actualización de los datos del formulario */

      managerRef
        .child(`forms/created/${formId}/formConfig`)
        .once("value")
        .then((snap) => {
          const managerforms = snap.val();
          const workshopRescuers = managerforms.formationGroups;
          const refreshRescuers = managerforms.refreshmentGroups;

          // 🟣 construir grupos actuales con Number() seguro
          let currentFormationGroups = workshops.map((w, i) => {
            const cap = Number(w.capacity) || 0;
            const rescCount = workshopRescuers[i]?.rescuers?.length || 0;

            return {
              text: `${workshopsMainLocation} ${w.locationDetail} · ${moment(w.time).format("dddd DD MMM HH:mm")}`,
              place: `${workshopsMainLocation} ${w.locationDetail}`,
              mainPlace: workshopsMainLocation,
              locationDetail: w.locationDetail,
              time: moment(w.time).valueOf(),
              capacity: cap,
              rescuers: workshopRescuers[i]?.rescuers ?? [],
              remaining: Math.max(0, cap - rescCount),
            };
          });

          console.log(currentFormationGroups);

          managerRef
            .child(`forms/created/${formId}/formConfig`)
            .update({
              endDay: moment(endDay).format("DD/MM/YYYY"),
              name: formName,
              formationGroups: currentFormationGroups,
              titles: name,
              refreshmentGroups: refreshmentGroups.map((r, i) => {
                const cap = Number(r.capacity) || 0;
                const rescCount = refreshRescuers[i]?.rescuers?.length || 0;
                return {
                  time: moment(r.time).valueOf(),
                  locationDetail: r.locationDetail ?? null,
                  capacity: cap,
                  rescuers: refreshRescuers[i]?.rescuers ?? [],
                  remaining: Math.max(0, cap - rescCount),
                };
              }),
            })
            .then(() => {
              // 🟣 actualizamos también en rescuersFormsRef
              firebase.rescuersFormsRef(formId).update({
                endDay: moment(endDay).format("DD/MM/YYYY"),
                name: formName,
                formationGroups: currentFormationGroups,
                titles: name,
                refreshmentGroups: {
                  ...refreshmentGroupsData,
                  startDay: moment(refreshmentGroupsData.startDay).format("DD/MM/YYYY"),
                  endDay: moment(refreshmentGroupsData.endDay).format("DD/MM/YYYY"),
                  groups: refreshmentGroups.map((r, i) => {
                    const cap = Number(r.capacity) || 0;
                    const rescCount = refreshRescuers[i]?.rescuers?.length || 0;
                    return {
                      time: moment(r.time).valueOf(),
                      locationDetail: r.locationDetail ?? null,
                      capacity: cap,
                      remaining: Math.max(0, cap - rescCount),
                    };
                  }),
                },
              });
              setIsFormCreated(true);
              setIsWorking(false);
            })
            .catch(() => setIsWorking(false));
        });
    }
  };

  const addNewCourseToUsers = (ref, users, data) => {
    /* actualiza usuario a usuario con la 
       información del curso de refresco*/
    if (users?.length == 0) {
      ref.parent.update({ allUsersUpdated: true });
    } else {
      try {
        let user = users.shift();
        firebase
          .user(user)
          .child("sgpfc/onSiteTrainings/forms")
          .update(data)
          .then(() => {
            addNewCourseToUsers(ref, users, data);
          });
      } catch (error) {
        console.log("Error en la creación de los usuarios", error, "--lista de usuarios--", users);
        ref.parent.update({ allUsersUpdated: false });
        addNewCourseToUsers(ref, users, data);
      }
    }
  };

  if (!isLoading) {
    if (!formExist) {
      return <Typography>No hay datos del formulario</Typography>;
    } else if (!preview) {
      return (
        <Container style={{ marginBottom: 64, marginTop: 32 }}>
          <Grid container spacing={5}>
            <Grid item container spacing={2}>
              <Grid item xs={12}>
                <Button variant="outlined" color="primary" onClick={() => history.push(ROUTES.MANAGE_FORMS)}>
                  Volver
                </Button>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h4" color="primary">
                  Meta formulario de registro
                </Typography>
                <Typography variant="h5" color="textSecondary">
                  Selecciona las opciones para el el formulario de registro (*) campos requeridos
                </Typography>
              </Grid>
            </Grid>

            <Grid item container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h6" color="primary">
                  Configuración del fromulario
                </Typography>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <TextField
                  id="outlined-basic"
                  label="Nombre del formulario"
                  placeholder="Formación Ermua Julio 22"
                  variant="outlined"
                  value={formName}
                  fullWidth
                  onChange={(e) => setFormName(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel id="program-select-label">Programa</InputLabel>
                  <Select labelId="program-select-label" value={program} disabled={isEdditing} onChange={(e) => setProgram(e.target.value)} label="Programa">
                    {Object.keys(availableGroups).map((e) => (
                      <MenuItem value={e}>{availableGroups[e].name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel id="group-select-label">Grupo</InputLabel>
                  <Select labelId="group-select-label" value={group} onChange={(e) => setGroup(e.target.value)} label="Grupo" disabled={program == "" || isEdditing}>
                    {program != "" &&
                      Object.keys(availableGroups[program].groups).map((e, i) => (
                        <MenuItem value={e} key={i}>
                          {availableGroups[program].groups[e].name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3} lg={2}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel id="alert-enabled-select-label">Acceso a Reanibex Alert</InputLabel>
                  <Select
                    labelId="alert-enabled-select-label"
                    value={alertEnabled}
                    disabled={isEdditing}
                    onChange={(e) => setAlertEnabled(e.target.value)}
                    label=" Acceso a Reanibex Alert"
                  >
                    <MenuItem value={false}>NO</MenuItem>
                    <MenuItem value={true}>SI</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6} lg={5}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel id="form-type-select-label">Tipo de formulario</InputLabel>
                  <Select labelId="form-type-select-label" value={formType} onChange={(e) => setFormType(e.target.value)} disabled={isEdditing} label="Tipo de formulario">
                    <MenuItem value={FORM_TYPES.FREE}>Formulario de libre acceso durante un periodo de fechas</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <MuiPickersUtilsProvider utils={MomentUtils}>
                <Grid item xs={12} md={6} lg={3}>
                  <KeyboardDatePicker
                    autoOk
                    variant="inline"
                    inputVariant="outlined"
                    label="Fecha de apertura del registro"
                    format="YYYY/MM/DD"
                    fullWidth
                    value={startDay}
                    minDate={!formId && new Date()}
                    invalidDateMessage={t("invalidDate")}
                    minDateMessage={t("minDateMessage")}
                    InputAdornmentProps={{ position: "end" }}
                    disabled={isEdditing}
                    onChange={(date) => {
                      setStartDay(date);
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <KeyboardDatePicker
                    autoOk
                    variant="inline"
                    inputVariant="outlined"
                    label="Fecha de cierre del registro"
                    format="YYYY/MM/DD"
                    fullWidth
                    value={endDay}
                    minDate={startDay}
                    invalidDateMessage={t("invalidDate")}
                    minDateMessage="La fecha tiene que ser posterior a la de apertura"
                    InputAdornmentProps={{ position: "end" }}
                    onChange={(date) => {
                      setEndDay(date);
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={3} lg={2}>
                  <FormControl variant="outlined" fullWidth>
                    <InputLabel id="form-type-select-label">Cursos de refresco</InputLabel>
                    <Select
                      labelId="form-type-select-label"
                      value={isRefreshmentGroups}
                      disabled={refreshmentHastUSers}
                      onChange={(e) => setisRefreshmentGroups(e.target.value)}
                      label="Cursos de refresco"
                    >
                      <MenuItem value={true}>SI</MenuItem>
                      <MenuItem value={false}>NO</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </MuiPickersUtilsProvider>
            </Grid>

            <MuiPickersUtilsProvider utils={MomentUtils}>
              <Grid item container spacing={3}>
                <Grid item xs={12}>
                  <Collapse in={isRefreshmentGroups}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography variant="h6" color="primary">
                          Grupos de refresco
                        </Typography>
                      </Grid>
                      <Grid item container spacing={2}>
                        <Grid item xs={12} md={6} lg={4}>
                          <TextField
                            id="outlined-basic"
                            label="Lugar de la formación"
                            placeholder="Izarra Centre"
                            variant="outlined"
                            value={refreshmentGroupsData.place}
                            fullWidth
                            onChange={(e) => setRefreshmentGroupsData({ ...refreshmentGroupsData, place: e.target.value })}
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                          <DatePicker
                            label="Inicio de inscripciones"
                            value={refreshmentGroupsData.startDay}
                            onChange={(e) => setRefreshmentGroupsData({ ...refreshmentGroupsData, startDay: e })}
                            inputVariant="outlined"
                            minDate={!isEdditing && moment()}
                            minDateMessage="la fecha no puede ser anterior a hoy"
                            fullWidth
                            ampm={false}
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                          <DatePicker
                            label="Fin de inscripciones"
                            value={refreshmentGroupsData.endDay}
                            onChange={(e) => setRefreshmentGroupsData({ ...refreshmentGroupsData, endDay: e })}
                            inputVariant="outlined"
                            minDate={moment(refreshmentGroupsData.startDay)}
                            minDateMessage="La fecha no puede ser anterior a la de inicio"
                            fullWidth
                            ampm={false}
                          />
                        </Grid>

                        <Grid item xs={12} md={6} lg={2}>
                          <TextField
                            id="outlined-basic"
                            label="Duración"
                            type="number"
                            placeholder="2"
                            variant="outlined"
                            InputProps={{
                              startAdornment: <InputAdornment position="start">Horas </InputAdornment>,
                            }}
                            value={refreshmentGroupsData.duration}
                            fullWidth
                            onChange={(e) => setRefreshmentGroupsData({ ...refreshmentGroupsData, duration: e.target.value })}
                          />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <FormControl variant="outlined" fullWidth>
                            <InputLabel id="alert-enabled-select-label">Descartar usuarios para refresco</InputLabel>
                            <Select
                              labelId="alert-enabled-select-label"
                              value={null}
                              disabled={isEdditing}
                              onChange={(e) => {
                                let aux = excludedFormsList;
                                aux.indexOf(e.target.value) == -1 ? aux.push(e.target.value) : aux.splice(aux.indexOf(e.target.value), 1);
                                setExcludedFormsList(aux.map((k) => k));
                              }}
                              label="Descartar usuarios para refresco"
                            >
                              {othersForms.map((og) => (
                                <MenuItem value={og.key}>
                                  {typeof og?.formConfig.name == "object" ? og.formConfig.name.es : og?.formConfig.name}
                                  {` · ${og.formConfig.startDay}`}
                                  {excludedFormsList.includes(og.key) && <Check />}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item container spacing={2}>
                          {refreshmentGroups.map((e, i) => (
                            <Grid container item xs={12} lg={3}>
                              <Card style={{ width: "100%", padding: 16, borderRadius: 12, justifyContent: "center" }} elevation={4}>
                                <Grid xs={12} item container spacing={1}>
                                  <Grid item xs={12}>
                                    <Tooltip title={<Typography>Si hay algun usuario registrado no se puede eliminar el grupo</Typography>}>
                                      <Typography variant="h6" color="textSecondary" gutterBottom>
                                        {`Grupo de refresco ${i + 1}`}{" "}
                                        <IconButton
                                          size="small"
                                          style={{ alignSelf: "flex-end", color: red[500] }}
                                          disabled={e.hasRescuers}
                                          onClick={() => {
                                            let aux = refreshmentGroups;
                                            aux.splice(i, 1);
                                            setRefreshmentGroups(aux.map((k) => k));
                                          }}
                                        >
                                          <Delete style={{ color: e.hasRescuers ? grey[500] : red[500] }} />
                                        </IconButton>
                                      </Typography>
                                    </Tooltip>
                                  </Grid>

                                  <Grid item xs={12}>
                                    <TextField
                                      variant="outlined"
                                      label="Detalles ubicación"
                                      value={e.locationDetail}
                                      size="small"
                                      fullWidth
                                      onChange={(e) => {
                                        let aux = refreshmentGroups;
                                        aux[i] = { ...aux[i], locationDetail: e.target.value };
                                        setRefreshmentGroups(aux.map((k) => k));
                                      }}
                                    />
                                  </Grid>

                                  <Grid item xs={12} lg={5}>
                                    <TextField
                                      type="number"
                                      value={e.capacity ?? ""}
                                      size="small"
                                      label="Capacidad"
                                      fullWidth
                                      variant="outlined"
                                      inputProps={{ min: 0, step: 1 }}
                                      onChange={(ev) => {
                                        const raw = ev.target.value;
                                        const val = raw === "" ? "" : Number(raw);
                                        if (val === "" || (!isNaN(val) && val >= 0)) {
                                          const aux = [...refreshmentGroups];
                                          aux[i] = { ...aux[i], capacity: val };
                                          setRefreshmentGroups(aux);
                                        }
                                      }}
                                    />
                                  </Grid>
                                  <Grid item xs={12} lg={7}>
                                    <DateTimePicker
                                      minDate={!isEdditing && moment()}
                                      gutterBottom
                                      fullWidth
                                      inputVariant="outlined"
                                      size="small"
                                      label="Fecha y hora"
                                      ampm={false}
                                      value={moment(e.time)}
                                      onChange={(e) => {
                                        let aux = refreshmentGroups;
                                        aux[i] = { ...aux[i], time: e };
                                        setRefreshmentGroups(aux.map((k) => k));
                                      }}
                                    />
                                  </Grid>

                                  {/*<Typography variant="badoy1" color="textPrimary" gutterBottom style={{ fontWeight: 500, fontSize: "1.1rem" }}>
                                    {`${moment(e.time).format("dddd DD MMM · HH:mm")} - ${moment(e.time).add(refreshmentGroupsData.duration, "hours").format("HH:mm")}`}
                                    </Typography>
                                  <Typography variant="badoy1" color="textPrimary" style={{ fontWeight: 500, fontSize: "1.1rem" }}>
                                    {`Capacidad: ${e.capacity} voluntarios`}
                                  </Typography>*/}
                                </Grid>
                              </Card>
                            </Grid>
                          ))}
                          <Grid item xs={12} lg={3}>
                            <Button
                              variant="outlined"
                              color="primary"
                              fullWidth
                              style={{ height: "100%", borderRadius: 16, minHeight: 170 }}
                              onClick={() => {
                                setRefreshmentGroups([...refreshmentGroups, { capacity: "", locationDetail: "" }]);
                              }}
                            >
                              Nuevo grupo de refresco
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Collapse>
                </Grid>
              </Grid>
            </MuiPickersUtilsProvider>

            <Grid item container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h6" color="primary">
                  Grupos de nuevos voluntarios
                </Typography>
              </Grid>
              <Grid container item xs={12}>
                <Grid item xs={4}>
                  <TextField
                    label="Lugar de la formación nuevos voluntarios"
                    placeholder="ej. Izarra centre sala de reuniones"
                    variant="outlined"
                    value={workshopsMainLocation}
                    fullWidth
                    onChange={(e) => setWorkshopsMainLocation(e.target.value)}
                  />
                </Grid>
              </Grid>
              {workshops.map((e, i) => (
                <Grid container item xs={12} lg={3}>
                  <Card style={{ width: "100%", padding: 16, borderRadius: 12, justifyContent: "center" }} elevation={4}>
                    <Grid xs={12} item container spacing={1}>
                      <Grid item xs={12}>
                        <Tooltip title={<Typography>Si hay algun usuario registrado no se puede eliminar el grupo</Typography>}>
                          <Typography variant="h6" color="textSecondary" gutterBottom>
                            {`Grupo ${i + 1}`}{" "}
                            <IconButton
                              size="small"
                              style={{ alignSelf: "flex-end", color: red[500] }}
                              disabled={e.hasRescuers}
                              onClick={() => {
                                let aux = workshops;
                                aux.splice(i, 1);
                                setWorkshops(aux.map((k) => k));
                              }}
                            >
                              <Delete style={{ color: e.hasRescuers ? grey[500] : red[500] }} />
                            </IconButton>
                          </Typography>
                        </Tooltip>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          value={e.locationDetail}
                          size="small"
                          fullWidth
                          variant="outlined"
                          label={"Detalles ubicación"}
                          onChange={(e) => {
                            let aux = workshops;
                            aux[i] = { ...aux[i], locationDetail: e.target.value };
                            setWorkshops(aux.map((k) => k));
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} lg={4}>
                        <TextField
                          type="number"
                          value={e.capacity ?? ""}
                          size="small"
                          label="Capacidad"
                          fullWidth
                          variant="outlined"
                          inputProps={{ min: 0, step: 1 }}
                          onChange={(ev) => {
                            const raw = ev.target.value;
                            const val = raw === "" ? "" : Number(raw);
                            if (val === "" || (!isNaN(val) && val >= 0)) {
                              const aux = [...workshops];
                              aux[i] = { ...aux[i], capacity: val };
                              setWorkshops(aux);
                            }
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} lg={8}>
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                          <DateTimePicker
                            minDate={!isEdditing && moment()}
                            gutterBottom
                            fullWidth
                            inputVariant="outlined"
                            label="Fecha y hora"
                            size="small"
                            ampm={false}
                            value={moment(e.time)}
                            onChange={(e) => {
                              let aux = workshops;
                              aux[i] = { ...aux[i], time: e };
                              setWorkshops(aux.map((k) => k));
                            }}
                          />
                        </MuiPickersUtilsProvider>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              ))}
              <Grid container item xs={12} lg={3}>
                <Button
                  variant="outlined"
                  color="primary"
                  fullWidth
                  style={{ height: "100%", borderRadius: 16, minHeight: 170 }}
                  onClick={() => {
                    setWorkshops([...workshops, { capacity: "", locationDetail: "" }]);
                  }}
                >
                  Nuevo grupo de voluntarios
                </Button>
              </Grid>
            </Grid>

            <NameTranslate names={name} setNames={setName} />

            <Grid item container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h6" color="primary">
                  Campos por defecto en el formulario
                </Typography>
              </Grid>
              <Grid item xs={12} container spacing={1}>
                <RequiredFieldsCard />
              </Grid>
            </Grid>

            {false && (
              <Grid item container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="h6" color="primary">
                    Añadir campos personalizados (sin validación)
                  </Typography>
                </Grid>
                <CustomFields setCustomFields={setCustomFieldsList} customFields={customFieldsList} />
              </Grid>
            )}

            <Grid item container justify="flex-end" spacing={2}>
              <Button
                variant="outlined"
                style={{ textTransform: "none" }}
                disabled={!isValid && !isEdditing}
                onClick={() => {
                  window.scrollTo(0, 0);
                  setpreview(true);
                }}
              >
                Previsualizar Formulario
              </Button>
            </Grid>
          </Grid>
        </Container>
      );
    } else {
      return (
        <Grid
          container
          alignItems="center"
          justify="center"
          style={{
            minHeight: "100vh",
            backgroundColor: "#fafafa",
            paddingTop: 32,
          }}
        >
          <Grid item xs={12} md={8} lg={7} container spacing={4}>
            <FormConfigCard availableGroups={availableGroups} group={group} program={program} startDay={startDay} endDay={endDay} alertEnabled={alertEnabled} name={name} />
            <SignUpForm
              isPreview
              formationGroups={workshops.map((w) => ({
                text: `${workshopsMainLocation} ${w.locationDetail} · ${moment(w.time).format("dddd DD MMM HH:mm")}`,
                capacity: w.capacity,
              }))}
              formName={name}
            />
            <Grid item xs={12} container>
              <Grid item xs={6} container justify="flex-start">
                <Button
                  variant="outlined"
                  onClick={() => {
                    window.scrollTo(0, 0);
                    setpreview(false);
                  }}
                  style={{ textTransform: "none" }}
                >
                  Volver
                </Button>
              </Grid>
              <Grid item xs={6} container justify="flex-end">
                <Button variant="outlined" color="primary" disabled={!isValid || isWorking} onClick={uploadFormData} style={{ textTransform: "none" }}>
                  {isEdditing ? "Aplicar cambios" : "Guardar y generar url"}
                  {isWorking && (
                    <CircularProgress
                      size={24}
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        marginTop: -12,
                        marginLeft: -12,
                      }}
                    />
                  )}
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Dialog
            onClose={() => {
              history.push(ROUTES.MANAGE_FORMS);
            }}
            fullWidth={true}
            maxWidth="sm"
            aria-labelledby="simple-dialog-title"
            open={isFormCreated}
          >
            <DialogTitle id="simple-dialog-title">{isEdditing ? "Formulario Actualizado" : "Formulario Creado"}</DialogTitle>
            <DialogContent>
              {!isEdditing ? (
                <Grid item xs={12} container alignItems="flex-end" justify="space-between">
                  <Grid item xs={4}>
                    <QRCode value={formUrl} />,
                  </Grid>
                  <Grid item xs={8} container direction="row" alignItems="center">
                    <Grid item xs={10}>
                      <Typography variant="body1">URL: {formUrl.substring(0, 30)}...</Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Tooltip title="Copiar url" aria-label="add">
                        <IconButton
                          style={{ marginLeft: 6 }}
                          onClick={() => {
                            setSnackOpen(true);
                            navigator.clipboard.writeText(formUrl);
                          }}
                        >
                          <FilterNone />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </Grid>
              ) : (
                <Grid container alignItems="center" justify="center">
                  <Lottie animationData={require("../../assets/93112-security.json")} style={{ height: "80%", width: "80%" }} />
                </Grid>
              )}
            </DialogContent>
            <DialogActions>
              {isEdditing && (
                <Button
                  onClick={() => {
                    history.push(ROUTES.MANAGE_FORMS);
                  }}
                >
                  Aceptar
                </Button>
              )}
            </DialogActions>
          </Dialog>
          <Snackbar
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            open={snackOpen}
            autoHideDuration={3000}
            onClose={() => setSnackOpen(false)}
            message="Copiado al portapapeles"
          />
        </Grid>
      );
    }
  } else {
    return (
      <Container>
        <Grid container alignItems="center" justify="center" style={{ height: "90vh" }}>
          <Grid item xs={12} lg={6}>
            <Lottie animationData={require("../../assets/adminLoading.json")} autoplay />
          </Grid>
        </Grid>
      </Container>
    );
  }
};

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(MetaForms);
